import React from 'react'

type Props = { children: React.ReactNode[] }
const QuestionsWrapper: React.FC<Props> = ({ children }) => {
  return (
    <div className='flex flex-col sm:flex-row sm:flex-wrap gap-y-3 justify-center gap-x-3 mb-8'>
      {children}
    </div>
  )
}

export default QuestionsWrapper
